'use client'

import s from './Industries.module.scss';
import {IndustriesSlider} from "@/app/[locale]/common/components/Industries/IndustriesSlider/IndustriesSlider";
import {Label} from "@/app/[locale]/common/components/Label/Label";
import {Line} from "@/app/[locale]/common/components/Line/Line";
import {IndustriesCard} from "@/app/[locale]/common/components/Industries/IndustriesCard";
import {SliderButtonsGroup} from "@/app/[locale]/common/components/SliderButtonsGroup/SliderButtonsGroup";
import {useTranslations} from "next-intl";
import {TIndustriesCardProps} from "@/app/[locale]/common/components/Industries/types";

export const Industries = () => {
    const t = useTranslations('MainPage.Industries');

    return (
        <section className={s.industries}>
            <div className={s.industries_labelContainer}>
                <Label>{ t('title') }</Label>
                <Line className={s.industries_line} />
                <SliderButtonsGroup navigationId={'industries'} />
            </div>
            <IndustriesSlider
                data={t.raw('data')}
                navigationId={'industries'}
                renderSlide={(item, index) => (
                    <IndustriesCard
                        key={index}
                        label={(item as TIndustriesCardProps).label}
                        text={(item as TIndustriesCardProps).text}
                        href={(item as TIndustriesCardProps).href}
                        image={(item as TIndustriesCardProps).image}
                    />
                )}
            />
        </section>
    );
};